import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    logoDisplay: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #E1E1E1',
        borderRadius: '2px',
        height: '380px',
    },

    imageBox: ({ width, height }) => ({
        width,
        height,
        border: '1px solid #B2B2B2',
        borderRadius: '4px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }),

    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    },

    imagePlaceholder: {
        width: '64px',
        height: '64px',
        objectFit: 'contain',
        display: 'block',
    },

    imageControls: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '8px',
    },

    iconButton: {
        width: '36px',
        height: '36px',
    },
}));
